import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

// 企業識別主色：#0072CE、#582C83
// 企業識別輔助色：#FFFFFF、#333F48、#00A3AD
const vuetifyOpts = {
    rtl: false,
    theme: {
        dark: false,
        themes: {
            light: {
                primary: "#0072CE",
                secondary: "#582C83",
                accent: "#00A3AD",
                success: "#66BB6A",
                info: "#0072CE",
                warning: "#FB8C00",
                error: "#FF5252",
                background: "#FFFFFF",
                surface: "#FFFFFF",
            },
            dark: {
                primary: "#0072CE",
                secondary: "#582C83",
                accent: "#00A3AD",
                success: "#66BB6A",
                info: "#0072CE",
                warning: "#FB8C00",
                error: "#FF5252",
                background: "#333F48",
                surface: "#333F48",
            },
        }
    }
};

export default new Vuetify(vuetifyOpts);
